export interface NewsletterConsentContent {
  newsletter: { summary: string; text: string };
  marketing: { summary: string; text: string };
  privacy: string;
}

export const defaultNewsletterCard = {
  image: '/assets/newsletter/alle.svg',
  sending_frequency: 'Regelmäßig',
};

export const newsletterPlaceholderImages: Record<string, string> = {
  'tvm-nl-alle': '/assets/newsletter/alle.svg',
  'tvm-nl-tvserien': '/assets/newsletter/tvserien.svg',
  'tvm-nl-streaming': '/assets/newsletter/streaming.svg',
  'tvm-nl-kino': '/assets/newsletter/kino.svg',
  'tvm-nl-tvm': '/assets/newsletter/magazin.svg',
  'tvm-nl-fussball': '/assets/newsletter/fussball.svg',
};

export const defaultNewsletterTeaser = {
  teaser_headline: 'Bleib immer up-to-date',
  teaser_text:
    '<p>Was bewegt dich? Was begeistert dich? Was lässt dich nicht mehr los?</p><p>Unsere Newsletter bringen genau die Themen zu dir, die dein Leben spannender und inspirierender machen.</p><p>Folge deiner Neugier und verpasse nichts, was dir wirklich wichtig ist.</p>',
  teaser_cta_label: 'Newsletter entdecken',
};

export const defaultNewsletterConsent: NewsletterConsentContent = {
  newsletter: {
    summary: 'Ja, ich möchte die TV-MEDIA-Newsletter regelmäßig per E-Mail erhalten.',
    text: 'Ja, ich möchte die TV-MEDIA-Newsletter regelmäßig per E-Mail erhalten und willige ein, dass meine personenbezogenen Daten (Vor- und Nachname, Anrede, Titel, E-Mail-Adresse, Nutzung von bzw. Interaktion mit Mailings, wie Bouncerate, Zustellung, Öffnungs- und Klickverhalten, IP-Adresse und sowie Browser- und Gerätedaten) durch die TV Media GmbH & Co KG zum Zweck der Zusendung, Erfolgsauswertung und Erstellung newsletterbezogener Nutzungsstatistiken verarbeitet werden. Die TV-MEDIA-Newsletter enthalten neben redaktionellen Inhalten auch kommerzielle Kommunikation (Werbeanzeigen) Dritter. Die Zusendung kann ich jederzeit widerrufen, z.B. durch den in jedem Newsletter enthaltenen Abmeldelink.',
  },
  marketing: {
    summary:
      'Ja, ich möchte personalisierte Werbung der VGN-Gruppe zu Magazinen, Online-Medien, Abos, Gewinnspielen und Veranstaltungen per E-Mail, SMS, Telefon und Post erhalten.',
    text: 'Ja, ich möchte personalisierte Werbung der VGN-Gruppe zu Magazinen, Online-Medien, Abos, Gewinnspielen und Veranstaltungen per E-Mail, SMS, Telefon und Post erhalten. Dafür dürfen die Unternehmen der VGN-Gruppe – die vollständige Liste finden Sie unter <a href="https://vgn.at/unternehmensgruppe" target="_blank" rel="noopener noreferrer">vgn.at/unternehmensgruppe</a> – meine Kontaktdaten und mein Nutzungsverhalten (Abos, Käufe, Interessen, Reaktionen auf Mailings, Website- und App-Nutzung) zu einem Werbeprofil verbinden und den Werbeerfolg messen. Widerruf jederzeit an <a href="mailto:datenschutz@vgn.at" class="underline">datenschutz@vgn.at</a>. Mehr dazu in der <a href="https://vgn.at/datenschutzpolicy" target="_blank" rel="noopener noreferrer">vgn.at/datenschutzpolicy</a>.',
  },
  privacy:
    'Die Rechtmäßigkeit der Datenverarbeitung bleibt bis zum Zeitpunkt eines allfälligen Widerrufs unberührt. Die Einwilligung ist freiwillig. Nähere Informationen zum Datenschutz finden Sie unter <a href="https://vgn.at/datenschutzpolicy" class="underline" target="_blank" rel="noopener noreferrer">vgn.at/datenschutzpolicy</a>.',
};
